import { ref, computed, watch } from 'vue'
import { apiClient } from '../services/apiClient'
import type { MapPlace } from '../types/map'

export function useMapLookup() {
  const bookId = ref<number | null>(null)
  const chapter = ref<number | null>(null)
  const filterVerse = ref<number | null>(null)
  const selectedPlaceId = ref<string | null>(null)
  const places = ref<MapPlace[]>([])
  const loading = ref(false)
  const error = ref<string | null>(null)
  const openSelectMenu = ref<'book' | 'chapter' | null>(null)

  const filteredPlaces = computed(() => {
    if (filterVerse.value === null) return places.value
    return places.value.filter(p => p.verses.includes(filterVerse.value!))
  })

  const loadChapterPlaces = async () => {
    if (bookId.value === null || chapter.value === null) {
      places.value = []
      return
    }
    loading.value = true
    error.value = null
    try {
      const data = await apiClient.getChapterPlaces(bookId.value, chapter.value)
      places.value = data
      selectedPlaceId.value = null
      filterVerse.value = null
    } catch (err: any) {
      error.value = err.message || '無法載入地名資料'
      places.value = []
    } finally {
      loading.value = false
    }
  }

  watch([bookId, chapter], () => {
    loadChapterPlaces()
  }, { immediate: false })

  const isValidChapter = computed(() => {
    if (bookId.value === null || chapter.value === null) return true
    return chapter.value >= 1 && chapter.value <= 150
  })

  return {
    bookId,
    chapter,
    filterVerse,
    openSelectMenu,
    isValidChapter,
    places: filteredPlaces,
    allPlaces: places,
    loading,
    error,
    selectedPlaceId,
    loadChapterPlaces
  }
}
